import { CfarFintechMarketplaceProduct } from "./components";
import { useInitFintechProductOffers } from "./hooks";

export const CfarFintechMarketplaceProductConfig = {
  name: "cfar" as const,
  View: CfarFintechMarketplaceProduct,
  useInit: useInitFintechProductOffers,
};
